import { HttpErrorResponse } from '@angular/common/http';

import { createEntityCollectionStore, ngrxEvent } from '@recruitee/ngrx';
import type { Referrer, TableDataParams } from '@recruitee/referrals-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Referrer>()(
  'ReferralsReferrerCollection',
  {
    customActions: adapter => ({
      fetchPaginatedCollection: (state, payload: { params: Partial<TableDataParams> }) =>
        adapter.markAsPending(state),
      deleteMany: (state, payload: { ids: number[] }) =>
        adapter.markAsPending(state, { entities: payload.ids, scope: null }),
      deleteManySuccess: (state, payload: { ids: number[] }) =>
        adapter.removeMany(state, payload.ids),
      deleteManyFailed: (state, payload: { error: HttpErrorResponse; data: { ids: number[] } }) =>
        adapter.setError(state, payload.error),
      inviteReferrer: ngrxEvent<{ emails: string[]; message: string | null }>(),
      inviteReferrerSuccess: ngrxEvent<{ emailsSent: string[] }>(),
      inviteReferrerFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
    }),
  },
);

export {
  actions as ReferralsReferrerActions,
  reducer as ReferralsReferrerReducer,
  selectors as ReferralsReferrerSelectors,
  namespace as ReferralsReferrerNamespace,
};
